"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _matchesAllGates2 = _interopRequireDefault(require("./matchesAllGates"));

var _matchesAllScopes2 = _interopRequireDefault(require("./matchesAllScopes"));

var _matchesSomeGates2 = _interopRequireDefault(require("./matchesSomeGates"));

var _matchesSomeScopes2 = _interopRequireDefault(require("./matchesSomeScopes"));

var _hasPortalSetting2 = _interopRequireDefault(require("./hasPortalSetting"));

var Conditions =
/*#__PURE__*/
function () {
  function Conditions() {
    (0, _classCallCheck2.default)(this, Conditions);
  }

  (0, _createClass2.default)(Conditions, null, [{
    key: "shouldAccess",
    value: function shouldAccess(obj) {
      var keys = Object.keys(obj);

      if (keys.length !== 1) {
        throw new Error("There must only be a single root condition!");
      }

      var type = keys[0];

      if (!this[type]) {
        throw new Error(type + " is not a recognized condition type!");
      }

      var properties = obj[type];
      return Conditions[type](properties);
    }
  }, {
    key: "matchesSomeScopes",
    value: function matchesSomeScopes() {
      var matchingScopes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return (0, _matchesSomeScopes2.default)(matchingScopes);
    }
  }, {
    key: "matchesAllScopes",
    value: function matchesAllScopes() {
      var matchingScopes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return (0, _matchesAllScopes2.default)(matchingScopes);
    }
  }, {
    key: "matchesSomeGates",
    value: function matchesSomeGates() {
      var matchingGates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return (0, _matchesSomeGates2.default)(matchingGates);
    }
  }, {
    key: "matchesAllGates",
    value: function matchesAllGates() {
      var matchingGates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return (0, _matchesAllGates2.default)(matchingGates);
    }
  }, {
    key: "hasPortalSetting",
    value: function hasPortalSetting(portalSettingKey) {
      return (0, _hasPortalSetting2.default)(portalSettingKey);
    }
  }, {
    key: "or",
    value: function or(conditions) {
      var parsedConditions = conditions.map(function (condition) {
        return Conditions.shouldAccess(condition);
      });
      return function (params) {
        return parsedConditions.some(function (condition) {
          return condition(params);
        });
      };
    }
  }, {
    key: "and",
    value: function and(conditions) {
      var parsedConditions = conditions.map(function (condition) {
        return Conditions.shouldAccess(condition);
      });
      return function (params) {
        return parsedConditions.every(function (condition) {
          return condition(params);
        });
      };
    }
  }, {
    key: "not",
    value: function not(condition) {
      var parsedCondition = Conditions.shouldAccess(condition);
      return function (params) {
        return !parsedCondition(params);
      };
    }
  }]);
  return Conditions;
}();

exports.default = Conditions;
module.exports = exports.default;